import { Text, description} from "../zugferd_2_3_2/text"
export { Text, description }